import React from 'react'
import Landing from '../components/Landing'

function Home() {
  return (
    <Landing/>
  )
}

export default Home